import { defineBoot } from '@quasar/app-vite/wrappers';
import _isEmpty from 'lodash/isEmpty';
import { ASSET_TYPES } from 'src/services/constants';
import errorService from 'src/services/error';
import { updateDeviceCounts } from 'src/services/intercom';
import { logout, setApi as setLogoutApi } from 'src/services/logout';
import store from 'src/store';
import WorkerProxy from 'src/workers/WorkerProxy';

export default defineBoot(async ({ urlPath, router }) => {
  // don't run in iframe, minimal app context
  if (urlPath.startsWith('/frame')) {
    return;
  }

  const WorkerManager = new Worker(new URL('../workers/worker-manager.worker.js', import.meta.url), { type: 'module' });

  const workerManager = new WorkerProxy(WorkerManager);
  await workerManager.ready();

  const api = await workerManager.get('Api');
  const dataBroker = await workerManager.get('DataBroker');

  dataBroker.subscribe('assets/updateAssets', async ({ updates, action = 'update' }) => {
    const { [ASSET_TYPES.VEHICLE]: vehicleUpdates, [ASSET_TYPES.ASSET]: assetUpdates } = updates;

    if (!_isEmpty(vehicleUpdates)) {
      await store().dispatch(`vehicles/${action}Vehicles`, vehicleUpdates);
    }

    if (!_isEmpty(assetUpdates)) {
      await store().dispatch(`assets/${action}Assets`, assetUpdates);
    }

    store().dispatch('map/updateAssetsLayer', store().getters['assets/visibleAssets']);
  });

  dataBroker.subscribe('data/initialized', () => {
    const vehicles = store().getters['assets/vehicles'];
    const assets = store().getters['assets/assets'];
    updateDeviceCounts({ assets, vehicles });
    store().dispatch('app/idbReady');
  });

  dataBroker.subscribe('map/setIdealBounds', (bounds) => {
    store().dispatch('map/setIdealBounds', bounds);
  });

  dataBroker.subscribe('filtering/setFilteredTerms', (term) => {
    store().dispatch('filtering/setFilteredTerms', term);
  });

  dataBroker.subscribe('filtering/filtersInitialized', () => {
    store().dispatch('filtering/filtersInitialized');
  });

  dataBroker.subscribe('notifications/setNotifications', (data) => {
    store().dispatch('notifications/setNotifications', data);
  });

  dataBroker.subscribe('notifications/setGetAllRequestId', (data) => {
    store().dispatch('notifications/setGetAllRequestId', data);
  });

  dataBroker.subscribe('filtering/setDefaultOutOfBoundsFilter', (filterOutOfBounds) => {
    store().dispatch('filtering/setDefaultOutOfBoundsFilter', filterOutOfBounds);
  });

  dataBroker.subscribe('errors/idbUnavailable', (data) => {
    errorService.log(new Error('IDB unavailable'), data);
    router.push({
      name: 'incompatible',
    });
  });

  api.subscribe('errors/apiError', ({ message, metadata, forceLogout, proposeRefresh }) => {
    if (forceLogout) {
      logout({ silent: true, redirect: window.location.pathname, logoutRedirect: '/invalid-session' });
      return;
    }

    errorService.notify({
      message,
      refreshAction: proposeRefresh,
      errorMeta: metadata,
    });
  });

  dataBroker.subscribe('app/pollingError', () => {
    store().dispatch('app/showPollingError');
  });

  dataBroker.subscribe('app/clearPollingError', () => {
    store().dispatch('app/clearPollingError');
  });

  store().commit('app/setBroker', dataBroker);
  store().commit('app/setApiWorker', api);

  setLogoutApi(api);

  // Tell rest of app the workers are ready
  store().dispatch('app/workersReady');
});
